
<div
  [class]="'notif-card w-full border-bottom-1 border-gray-300 p-3 flex gap-2 align-items-center cursor-pointer' + (notification.notificationTypes?.[0]?.isViewed ? ' ' : ' bg-primary-50')"
  (click)="markNotificationAsViewed();handleNotificationClick()">

  <div class="notif-logo">
    <div
      class="p-2 border-circle text-sm "
      [style.color]="getColorOnName(userListByEmail[notification.createdBy?.toLowerCase()?.trim() || ''].firstName)"
      [style.backgroundColor]="getLightColorOnColorName(userListByEmail[notification.createdBy?.toLowerCase()?.trim() || ''].firstName)"
    >
      {{notification.createdBy?.slice(0,2)?.toUpperCase()}}
    </div>
  </div>

  <div class="notif-main flex flex-column gap-1 flex-1 ml-3 relative">

    <div class="flex justify-content-between">

      <div>

        @if(!notification.notificationTypes?.[0]?.isViewed) {
          <div class=" notif-dot bg-primary border-circle absolute" ></div>
        }

        <div class="flex text-xs gap-1">
          @if(notification.context !== 'reminder') {
            <span class=" font-semibold">{{userListByEmail[notification.createdBy || ''].firstName}}</span>
          }
          @if(
            notification.context === 'comment' ||
            notification.context === 'reminder' ||
            notification.context === 'workspace' ||
            notification.context === 'shared' ||
            notification.context === 'claim_comment' ||
            notification.context === 'report_comment' ||
            notification.context === 'claim_status_change' ||
            notification.context === 'claim_assignment'
          ) {
            <span>{{notificationHeader[notification.context]}}</span>
          }
        </div>

      </div>

      <div class="notif-options align-self-baseline">
        <p class="m-0 p-0 text-xs text-gray-500">{{ notification.scheduledDate | timeAgo  }}</p>
      </div>
    </div>


    @if(notification.message) {
      <div
        [class]="'notif-message m-0 p-2  text-xs border-left-3 text-gray-500 border-primary border-round-sm ' + (notification.notificationTypes?.[0]?.isViewed ? ' surface-100 ' : ' surface-0 ')"
        [innerHTML]="notification.message || '' | sanitizer">
      </div>
    }
  </div>

</div>


